export default "__VITE_ASSET__B7e3OTVb__"